// extracted by mini-css-extract-plugin
module.exports = {"search-input":"FAQForm_search-input__2I86w","input-wrapper":"FAQForm_input-wrapper__1Tzjc","icon-wrapper":"FAQForm_icon-wrapper__1-BBd","icon-button":"FAQForm_icon-button__2-2Nv"};